/* eslint-disable */
import { Project } from '../index';

declare var Object: any;
export interface ProjectThemeInterface {
  id?: string;
  theme: any;
  customTheme?: any;
  projectId?: string;
  createdDate?: Date;
  createdBy?: string;
  createdById?: string;
  updatedDate?: Date;
  updatedBy?: string;
  updatedById?: string;
  project?: Project;
}

export class ProjectTheme implements ProjectThemeInterface {
  'id'?: string;
  'theme': any;
  'customTheme'?: any;
  'projectId': string;
  'createdDate': Date;
  'createdBy': string;
  'createdById': string;
  'updatedDate': Date;
  'updatedBy': string;
  'updatedById': string;
  project: Project;
  constructor(data?: ProjectThemeInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ProjectTheme`.
   */
  public static getModelName() {
    return 'ProjectTheme';
  }
  /**
   * @method factory
   * @author Jonathan Casarrubias
   * @license MIT
   * This method creates an instance of ProjectTheme for dynamic purposes.
   **/
  public static factory(data: ProjectThemeInterface): ProjectTheme {
    return new ProjectTheme(data);
  }
  /**
   * @method getModelDefinition
   * @author Julien Ledun
   * @license MIT
   * This method returns an object that represents some of the model
   * definitions.
   **/
  public static getModelDefinition() {
    return {
      name: 'ProjectTheme',
      plural: 'ProjectThemes',
      path: 'project-themes',
      idName: 'id',
      properties: {
        id: {
          name: 'id',
          type: 'string',
        },
        theme: {
          name: 'theme',
          type: 'any',
        },
        customTheme: {
          name: 'customTheme',
          type: 'any',
        },
        projectId: {
          name: 'projectId',
          type: 'string',
        },
        createdDate: {
          name: 'createdDate',
          type: 'Date',
        },
        createdBy: {
          name: 'createdBy',
          type: 'string',
        },
        createdById: {
          name: 'createdById',
          type: 'string',
        },
        updatedDate: {
          name: 'updatedDate',
          type: 'Date',
        },
        updatedBy: {
          name: 'updatedBy',
          type: 'string',
        },
        updatedById: {
          name: 'updatedById',
          type: 'string',
        },
      },
      relations: {
        project: {
          name: 'project',
          type: 'Project',
          model: 'Project',
          relationType: 'belongsTo',
          keyFrom: 'projectId',
          keyTo: 'id',
        },
      },
    };
  }
}
